import {RouterModule, Routes} from '@angular/router';
import {MasterPageComponent} from '../../master/masterpage.component';
import {AuthorizationCheck} from '../../auth/authorizationCheck';
import {ModuleWithProviders} from '@angular/core';
import {UpdateSecurityQuestionsComponent} from './update-security-questions/update-security-questions.component';
import {ChangeTempPasswordComponent} from './change-temp-password/change-temp-password.component';

const Config_Routes: Routes = [
  {
    path: 'updateSecurityQuestions',
    component: UpdateSecurityQuestionsComponent
  },
  {
    path: 'changeTempPassword',
    component: ChangeTempPasswordComponent
  }
];

export const accountRouting: ModuleWithProviders = RouterModule.forRoot(Config_Routes);
